import Cookies from 'universal-cookie';

// A 401 from one legacy route must not end a live session: the legacy stack has no
// auth authority that could confirm it, and one stray 401 from any of the ~675 legacy
// call sites used to bounce a freshly logged-in user to /login. Only a missing token
// logs out.
export async function invalidToken(message) {
    const cookies = new Cookies();
    if (cookies.get('ovToken')) return;
    _doLogout();
}

export function _doLogout() {
    const cookies = new Cookies();
    cookies.remove('ovUid');
    cookies.remove('ovToken');
    cookies.remove('ovUserName');
    cookies.remove('ovUserImage');
    cookies.remove('temp_ovUid');
    cookies.remove('temp_ovToken');
    cookies.remove('temp_ovUserName');
    cookies.remove('temp_ovUserImage');
    window.location.href = '/';
}
